import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=d6dcaa58&scoped=true"
import script from "./rate.vue?vue&type=script&lang=js"
export * from "./rate.vue?vue&type=script&lang=js"
import style0 from "./rate.vue?vue&type=style&index=0&id=d6dcaa58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6dcaa58",
  null
  
)

export default component.exports